// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (settings-edit e settings-list)

import { Injectable } from '@angular/core';
import { Settings } from './settings.model';
import { Subject } from 'rxjs';

@Injectable()
export class SettingsService {
  private settings: Settings[] = [];
  settingsChanged = new Subject<Settings[]>();
  settingsEditMode = new Subject<number>();

  constructor(
  ) { }

  ngOnInit() {
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getSettings() {
    return this.settings;
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setSettings(settings: Settings[]) {
    if (settings !== null) {
      this.settings = settings;
      this.settingsChanged.next(this.settings.slice());
    }
  }

}
